import React from 'react';
import { Link } from 'react-router-dom';
import './SoftwareServices.css';

const SoftwareServices = () => {
  const services = [
    {
      title: 'CRM/ERP Implementation',
      description: 'Complete implementation and integration across sales, service, operations, and finance systems.',
      features: [
        'System configuration',
        'Custom workflows',
        'Integration with existing tools'
      ]
    },
    {
      title: 'Data Migration & Automation',
      description: 'Seamless data migration and workflow automation to reduce errors and accelerate cycles.',
      features: [
        'Data cleaning & migration',
        'Workflow optimization',
        'Process automation'
      ]
    },
    {
      title: 'Training & Adoption',
      description: 'Comprehensive training, documentation, and support to ensure high utilization and sustained ROI.',
      features: [
        'User training programs',
        'Documentation',
        'Ongoing support'
      ]
    },
    {
      title: 'Custom Development',
      description: 'Tailored websites and custom applications aligned to your unique workflows and requirements.',
      features: [
        'Custom web applications',
        'Business process tools',
        'API integrations'
      ]
    },
    {
      title: 'Managed Programs',
      description: 'Marketing and social media management to streamline operations and drive measurable outcomes.',
      features: [
        'Marketing automation',
        'Social media management',
        'Campaign tracking'
      ],
      link: '/services/software/managed-programs'
    },
    {
      title: 'Website Portfolio',
      description: 'Explore our diverse portfolio of successful website projects across various industries and business types.',
      features: [
        'E-commerce platforms',
        'Business websites',
        'Custom applications'
      ]
    }
  ];

  return (
    <div className="software-services-page">
      <section className="software-hero">
        <div className="software-hero-container">
          <div className="software-hero-content">
            <h1 className="software-hero-title">Business Software Services</h1>
            <p className="software-hero-description">
              With 20 years of CRM/ERP experience, we implement and integrate software to simplify workflows and accelerate your business. Software should work the way your business does—not the other way around. We take the time to understand your processes and configure solutions that fit naturally into your operations.
            </p>
            <Link to="/contact" className="btn-software-hero">Speak to an Expert</Link>
          </div>
          <div className="software-hero-image">
            <img 
              src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80" 
              alt="Business Software Solutions" 
            />
          </div>
        </div>
      </section>

      <section className="software-intro">
        <div className="software-container">
          <h2 className="software-section-title">Our Software Capabilities</h2>
          <p className="software-intro-text">
            Comprehensive solutions for implementation, integration, and ongoing support
          </p>
        </div>
      </section>

      <section className="software-services-grid">
        <div className="software-container">
          <div className="software-cards-grid">
            {services.map((service, index) => {
              const card = (
                <div key={index} className={`software-capability-card${service.link ? ' software-capability-card-link' : ''}`}>
                  <h3 className="software-capability-title">{service.title}</h3>
                  <p className="software-capability-description">{service.description}</p>
                  <ul className="software-capability-features">
                    {service.features.map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ul>
                  {service.link && <span className="software-card-arrow">→</span>}
                </div>
              );
              return service.link ? (
                <Link key={index} to={service.link} className="software-card-link-wrapper">
                  {card}
                </Link>
              ) : (
                card
              );
            })}
          </div>
        </div>
      </section>

      <section className="software-cta">
        <div className="software-container">
          <h2 className="software-cta-title">Ready to Simplify Your Workflows?</h2>
          <p className="software-cta-description">
            Let's discuss how our software services can streamline your processes and empower your teams.
          </p>
          <Link to="/contact" className="btn-software-primary">Speak to an Expert</Link>
        </div>
      </section>
    </div>
  );
};

export default SoftwareServices;
